<div>
	<div class="border mb-3 p-3">
		<div class="p-grid">
			<div class="p-col text-center">
				A {{ transaction.value | currency }} gift card for {{ transaction.recipientName }} sending to {{ transaction.recipientEmail }}.
				<span *ngIf="transaction.value !== transaction.transactionAmount">You'll be charged {{ transaction.transactionAmount | currency }}</span>
			</div>
		</div>
		<div>
			<app-i4go-payment
				*ngIf="eGiftVenue.Venue.ooVenue.ccProcessor === 1"
				[email]="transaction.purchaserEmail"
				[firstName]="transaction.purchaserFirstName"
				[lastName]="transaction.purchaserLastName"
				[orderId]="transaction.invoice"
				[transactionAmount]="transaction.transactionAmount"
				[venueKey]="eGiftVenue.venueKey"
				(i4goResponse)="paymentComplete($event)"
			></app-i4go-payment>
			<app-auth-net-payment
				*ngIf="eGiftVenue.Venue.ooVenue.ccProcessor === 2"
				[firstName]="transaction.purchaserFirstName"
				[lastName]="transaction.purchaserLastName"
				[transactionAmount]="transaction.transactionAmount"
				[venueKey]="eGiftVenue.venueKey"
				(i4goResponse)="paymentComplete($event)"
			></app-auth-net-payment>
			<app-focuspay-payment
				*ngIf="eGiftVenue.Venue.ooVenue.ccProcessor === 4"
				[transactionAmount]="transaction.transactionAmount"
				(processorResponseChange)="paymentComplete($event)"
			>
			</app-focuspay-payment>
			<app-datacap-payment
				*ngIf="eGiftVenue.Venue.ooVenue.ccProcessor === 5"
				[datacapApiSecret]="eGiftVenue.Venue.ooVenue.ccProcessorApiSecret"
				[transactionAmount]="transaction.transactionAmount"
				(i4goPaymentResponseDTOChange)="paymentComplete($event)"
			>
			</app-datacap-payment>
		</div>
		<div class="text-center" style="color: red">
			{{ transactionError }}
		</div>
	</div>
</div>
